import React from "react";
import { FormControlLabel, Checkbox, Stack } from "@mui/material";
import { globalTheme } from "../../styles";

interface CheckboxOption {
  label: string;
  checked: boolean;
  value: string; // Value associated with the checkbox
}

interface CustomCheckboxProps {
  checkbox: CheckboxOption[]; // Expecting an array of checkbox options
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void; // Change handler
}

export const CarrierCheckBox: React.FC<CustomCheckboxProps> = ({ checkbox, onChange }) => {
  return (
    <Stack spacing={2}>
      {checkbox.map((item, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={item.checked}
              onChange={(event) => onChange(event, item.value)} // Call onChange with item value
              sx={{
                color: `${globalTheme.primaryColor}`,
                "&.Mui-checked": {
                  color: `${globalTheme.primaryColor}`,
                },
              }}
            />
          }
          label={item.label}
        />
      ))}
    </Stack>
  );
};
